import { useLocation } from "react-router-dom";

import CloseIcon from "~/assets/icons/CloseIcon.svg?react";
import { PATTERNS } from "~/router/patterns";
import { Logo } from "~/utils/white-label";

import styles from "./LoginHeader.module.scss";

// Routes where the back arrow is meaningless: the user holds a token but
// cannot leave the page (AppGate or the onboarding guard would bounce them
// straight back), so the affordance would falsely imply an exit.
// `/demo-login` is entered from an email link — a fresh tab has no in-app
// history to go back to.
const ROUTES_WITHOUT_CLOSE: string[] = [
  PATTERNS.verifyMfa,
  PATTERNS.demoLogin,
  PATTERNS.onboardingPlatform,
  PATTERNS.onboardingSurvey,
];

const LoginHeader = () => {
  const { pathname } = useLocation();
  const showClose =
    !ROUTES_WITHOUT_CLOSE.includes(pathname) && window.history.length > 0;

  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <Logo />
      </div>
      {showClose && (
        <div className={styles.closeIcon} onClick={() => window.history.back()}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};
export default LoginHeader;
